import React from 'react';
import { useTranslation } from 'react-i18next';
import { MoreOptionsIcon } from 'src/SharedComponents/Icons/Icons';
import './MoreOptions.css';

interface IChildren {
    children: React.ReactNode;
    disabled?: boolean;
    floating?: boolean;
}

// Bootstrap JSON-parses data-bs-* attributes, so this reaches Popper as an object.
const FLOATING_POPPER_CONFIG = JSON.stringify({ strategy: 'fixed', placement: 'bottom-end' });

const MoreOptionsMenu: React.FC<IChildren> = ({children, disabled, floating}) => {
    const { t } = useTranslation();

    return (
        <div className={`moreButton ${floating ? 'floating-menu ' : ''}${disabled ? 'disabled' : ''}`}  >
            {/* By default data-bs-display="static" turns Popper off for this
                dropdown so the panel can be placed by CSS exactly where Figma
                puts it — flush under the trigger and aligned to its right edge.
                With Popper on, its inline transform wins over any positioning
                we write.
                `floating` is for a menu inside a clipping or scrolling container
                (the clinics table card), where a CSS-placed panel is cut off and
                makes the container scroll. Popper stays on with a fixed strategy
                so the panel escapes the container: bottom-end against the 56px
                .moreButton box with no gap, as Figma has it, flipping upward near
                the viewport bottom and following the page as it scrolls. */}
            <button
                type="button"
                className="menu-icon"
                id="dropdownMenuButton1"
                data-bs-toggle="dropdown"
                data-bs-display={floating ? undefined : 'static'}
                data-bs-reference={floating ? 'parent' : undefined}
                data-bs-offset={floating ? '0,0' : undefined}
                data-bs-popper-config={floating ? FLOATING_POPPER_CONFIG : undefined}
                aria-expanded="false"
                aria-label={t('MoreOptions')}
                disabled={disabled}
            >
                <MoreOptionsIcon />
            </button>
            {children}
        </div>
    );
};

export default MoreOptionsMenu;
